import { render } from "./AddSeatRow.vue?vue&type=template&id=48820c9a&scoped=true"
import script from "./AddSeatRow.vue?vue&type=script&lang=js"
export * from "./AddSeatRow.vue?vue&type=script&lang=js"

import "./AddSeatRow.vue?vue&type=style&index=0&id=48820c9a&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48820c9a"]])

export default __exports__